<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">G<span class="small">ETTING THE</span> M<span class="small">OST</span> O<span class="small">UT OF</span> <i>1 &amp; 2 P<span class="small">ETER AND</span> J<span class="small">UDE</span></i></a></div>
<div class="table" id="tableau-001">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:6px;">
<col style="width:5%;padding:6px;"/>
<col style="width:40%;padding:6px;"/>
<col style="width:55%;padding:6px;"/>
</colgroup>
<tbody>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><a href="#/chap1"><span class="mev2">1</span></a></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><a href="#/chap1">1 Peter 1:1-12</a></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><a href="#/chap1"><b>Strangers in the World</b></a></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap2" title="Link target outside of Sample"><span class="mev2">2</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">1 Peter 1:13-25</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><b>Called to Be Different</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap3" title="Link target outside of Sample"><span class="mev2">3</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">1 Peter 2:1-12</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><b>Do I Want to Grow Up?</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap4" title="Link target outside of Sample"><span class="mev2">4</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">1 Peter 2:13—3:7</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><b>In His Steps</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap5" title="Link target outside of Sample"><span class="mev2">5</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">1 Peter 3:8-22</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><b>If I’m Living Right, Then Why Do I Hurt So Much?</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap6" title="Link target outside of Sample"><span class="mev2">6</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">1 Peter 4</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><b>Christians at Risk</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap7" title="Link target outside of Sample"><span class="mev2">7</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">1 Peter 5</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><b>TLC for Trying Times</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap8" title="Link target outside of Sample"><span class="mev2">8</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample">2 Peter 1:1-11</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><b>The Long Way Home</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap9" title="Link target outside of Sample"><span class="mev2">9</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample">2 Peter 1:12-21</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><b>If I Should Die . . .</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap10" title="Link target outside of Sample"><span class="mev2">10</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample">2 Peter 2</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><b>Follow Which Leader?</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap11" title="Link target outside of Sample"><span class="mev2">11</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample">2 Peter 3</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><b>The Fire Next Time</b></span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap12" title="Link target outside of Sample"><span class="mev2">12</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample">Jude</span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample"><b>The Twisted Fate of Twisted Faith</b></span></p></td>
</tr>
</tbody></table></div></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Leader’s Notes</span></div><div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?bf624aea